/**
 * Zimmet türleri — liste ekranının filtreyi ve çalışan kartının sekmesi AYNI adları kullansın.
 *
 * Tür listesi koda gömülü DEĞİL (sunucu serbest metin kabul ediyor); bu, seçicide duran kümedir.
 * İki ekranın ayrı kopya tutması, birinde «Bilgisayar» öbüründe «LAPTOP» yazması demekti.
 *
 * 25 Ekim 2026: liste ÜÇE indi — zimmetlenen şey bu kurulumda bilgisayar, tablet ve telefon.
 * «Araç» filo modülünün işi (araç zimmeti `fleet_assignments`, teslim ve iade kendi akışında),
 * «Diğer» ise bir tür değil bir kaçış kapısıydı: seçildiğinde kaydın ne olduğunu yalnız açıklama
 * alanı söylüyordu ve liste filtreyi işe yaramaz hâle geliyordu.
 */
export const ASSET_KINDS = [
  { value: "LAPTOP", label: "Bilgisayar" },
  { value: "TABLET", label: "Tablet" },
  { value: "TELEFON", label: "Telefon" },
];

/**
 * ETİKET SÖZLÜĞÜ SEÇİCİDEN GENİŞ: seçicide artık olmayan türler (ARAC, DIGER) geçmişte verilmiş
 * zimmetlerde duruyor olabilir ve o satırlar ham kodu değil adını göstermeli.
 */
export const ASSET_KIND_LABELS: Record<string, string> = {
  ...Object.fromEntries(ASSET_KINDS.map((kind) => [kind.value, kind.label])),
  ARAC: "Araç",
  DIGER: "Diğer",
};

/**
 * Malın durumu (ik-ek 6 Ekim 2026, H12) — sunucunun `OK` / `DAMAGED` değerlerinin Türkçesi.
 *
 * `null` üçüncü bir değer: «kaydedilmemiş». Bu tarihten önce verilen zimmetlerde durum yok ve
 * onları «Sağlam» göstermek, hiç bakılmamış bir malı sağlam diye ilan etmek olurdu.
 */
export const ASSET_CONDITIONS = [
  { value: "OK", label: "Sağlam" },
  { value: "DAMAGED", label: "Hasarlı" },
] as const;

/**
 * İadede malın durumu — ik-duzeltme 19 Ekim 2026 (Z2): teslimin ikisi ve «Eksik parça», «Kayıp».
 * Liste filtreyi, iade penceresi ve rozet aynı sözlüğü okuyor.
 */
export const ASSET_RETURN_CONDITIONS = [
  ...ASSET_CONDITIONS,
  { value: "MISSING_PARTS", label: "Eksik parça" },
  { value: "LOST", label: "Kayıp" },
] as const;

/**
 * Notu zorunlu iade durumları — hasarın ne olduğu, neyin eksik olduğu, malın nasıl kaybolduğu
 * (sunucunun kuralı). Hasarlı iade İK denetiminden beri (19 Ekim 2026, İK-07 f) notsuz geçmiyor.
 */
export const RETURN_CONDITIONS_NEEDING_NOTE: ReadonlySet<string> = new Set([
  "DAMAGED",
  "MISSING_PARTS",
  "LOST",
]);

export const ASSET_CONDITION_LABELS: Record<string, string> = Object.fromEntries(
  ASSET_RETURN_CONDITIONS.map((condition) => [condition.value, condition.label]),
);
